import Message from 'components/Message';
import Text from 'components/Text';

interface Props {
	className?: string;
	description: string;
	heading: string;
	summary: string | undefined;
}

export default function ReviewAiSummary({
	className,
	description,
	heading,
	summary,
}: Props) {
	if (!summary) {
		return null;
	}

	return (
		<div className={className}>
			<Text as="h3" styleAs="strong" text={heading} />
			<Message className="mt-2" summarySender={description} variant="summary">
				<p className="text-md">{summary}</p>
			</Message>
		</div>
	);
}
ReviewAiSummary.displayName = 'ReviewAiSummary';
